import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {TenantModel} from '@/libs/Api';
import {AdminTenantsDataService} from '@/libs/admin-tenants/admin-tenants-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const adminTenantsStore = registerCrudStore<TenantModel, TenantModel>(BusinessModule.AdminTenant, new AdminTenantsDataService());
